import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      {/* Left Side - Logo & App Name */}
      <div className="nav-left">
        <Link to="/" className="logo" onClick={closeMenu}>
          <i className="fa-solid fa-broom"></i>
          <span>Cleanering</span>
        </Link>
      </div>

      {/* Right Side - Menu Links / Hamburger */}
      <div className="nav-right">
        {/* Hamburger Icon (mobile only) */}
        <div className="menu-icon" onClick={toggleMenu}>
          <i className={menuOpen ? "fa-solid fa-xmark" : "fa-solid fa-bars"}></i>
        </div>

        {/* Menu Links */}
        <div className={`nav-links ${menuOpen ? "active" : ""}`}>
          <Link to="/" onClick={closeMenu}>Home</Link>
          <Link to="/services" onClick={closeMenu}>Services</Link>
          <Link to="/delete-account" onClick={closeMenu}>Account Delete Request</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;